const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const API_BASE = `${API_ROOT}/api/operaciones-importacion`;
const CONCILIACION_API_BASE = `${API_ROOT}/api/operaciones-conciliacion`;

export const importacionOperacionesApi = {
  async analizar(formData, token) {
    return this.request(this.buildApiUrl("/analizar"), {
      method: "POST",
      headers: this.buildHeaders(token),
      body: formData,
    });
  },

  async analizarYGuardar(formData, token) {
    return this.request(this.buildApiUrl("/analizar-y-guardar"), {
      method: "POST",
      headers: this.buildHeaders(token),
      body: formData,
    });
  },

  async obtenerHistorial(token, filtros = {}) {
    const url = this.buildUrl("", token, filtros);
    return this.request(url, {
      headers: this.buildHeaders(token),
      cache: "no-store",
      debugLabel: "Historial",
    });
  },

  async obtenerImportacion(id, token) {
    return this.request(this.buildUrl(`/${id}`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async obtenerFilas(id, token) {
    return this.request(this.buildUrl(`/${id}/filas`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async obtenerIncidencias(id, token) {
    return this.request(this.buildUrl(`/${id}/incidencias`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async obtenerPreconfirmacion(id, token) {
    return this.request(this.buildUrl(`/${id}/preconfirmacion`, token), {
      headers: this.buildHeaders(token),
      cache: "no-store",
    });
  },

  async confirmar(id, token, payload = { confirmacionUsuario: true }) {
    return this.request(this.buildApiUrl(`/${id}/confirmar`), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  },

  async habilitarReintento(id, token) {
    return this.request(this.buildApiUrl(`/${id}/rehabilitar-reintento`), {
      method: "POST",
      headers: this.buildHeaders(token),
    });
  },

  async analizarZipFiserv(formData, token) {
    return this.request(this.buildConciliacionApiUrl("/fiserv/analizar-zip"), {
      method: "POST",
      headers: this.buildHeaders(token),
      body: formData,
    });
  },

  async obtenerDiagnosticoMapeoClover(payload, token) {
    return this.request(this.buildConciliacionApiUrl("/clover/diagnostico-mapeo"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  async solicitarReportesClover(payload, token) {
    return this.request(this.buildConciliacionApiUrl("/clover/solicitar-reportes"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  async conciliarFiservClover(payload, token) {
    return this.request(this.buildConciliacionApiUrl("/conciliar"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  async obtenerHistorialConciliacion(filtros = {}, token) {
    return this.request(this.buildConciliacionApiUrl("/historial"), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...filtros, token }),
      cache: "no-store",
    });
  },
  async crearReconciliationRun(formData, token) { return this.request(this.buildConciliacionApiUrl("/reconciliation-runs"), { method: "POST", headers: this.buildHeaders(token), body: formData }); },
  async iniciarReconciliationClover(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/clover`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token }) }); },
  async iniciarCloverNuevosMappings(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/clover/new-mappings`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token }) }); },
  async obtenerReconciliationRun(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  async obtenerReconciliationReports(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/reports`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  async obtenerHistorialReconciliation(token, take = 20) { const safeTake = Math.min(Math.max(Number(take) || 20, 1), 100); return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs?take=${safeTake}`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  async reintentarReconciliationFailed(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/reports/retry-failed`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token }) }); },
  async ejecutarReconciliationMatch(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/match`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token }) }); },
  async recalcularReconciliationDebit(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/debit-reconciliation/recalculate`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token }) }); },
  async resolverReconciliationDebitRow(runId, token, payload) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/debit-reconciliation/resolve`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token, ...payload }) }); },
  async simularReconciliationDebitAllClover(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/debit-reconciliation/simulate-all-clover`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ token }) }); },
  async obtenerReconciliationMatch(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/match`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  async resolverReconciliationReview(runId, payload, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/reviews/resolve`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ ...payload, token }) }); },
  async confirmarReconciliationMapping(runId, payload, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/mappings/confirm`), { method: "POST", headers: { ...this.buildHeaders(token), "Content-Type": "application/json" }, body: JSON.stringify({ ...payload, token }) }); },
  async buscarReconciliationMerchants(query, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-merchants/search?q=${encodeURIComponent(query)}`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  // Salud de los mappings terminal Fiserv <-> merchant Clover. Solo diagnostico: se deriva de
  // los reportes ya descargados y no cambia nada de la conciliacion.
  async obtenerMappingHealth(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/mapping-health`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  // Motor de pago: vista unificada (dataset + readiness + schedule + elegibilidad + financiero).
  // Auditoria Fiserv: universo del Builder, equivalente a la hoja SAS del conversor.
  async obtenerOperacionesFiserv(runId, token, filtros = {}) {
    const qs = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const sufijo = qs.toString() ? `?${qs}` : "";
    return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/fiserv-operations${sufijo}`), { headers: this.buildHeaders(token), cache: "no-store" });
  },
  buildExportOperacionesFiservUrl(runId, token, filtros = {}) {
    const qs = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    if (token) qs.append("token", token);
    return this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/fiserv-operations/export?${qs}`);
  },
  // Espejo de las de Fiserv, contra el universo Clover. Endpoint aparte a proposito: son
  // dos universos distintos y los campos no significan lo mismo.
  async obtenerOperacionesClover(runId, token, filtros = {}) {
    const qs = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const sufijo = qs.toString() ? `?${qs}` : "";
    return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/clover-operations${sufijo}`), { headers: this.buildHeaders(token), cache: "no-store" });
  },
  buildExportOperacionesCloverUrl(runId, token, filtros = {}) {
    const qs = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    if (token) qs.append("token", token);
    return this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/clover-operations/export?${qs}`);
  },
  async obtenerPaymentEngine(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/payment-engine/preview`), { headers: this.buildHeaders(token), cache: "no-store" }); },
  // Zoco Cuota a Cuota: simulacion read-only del recupero de cada cuota Fiserv contra su madre Clover.
  async obtenerCuotaACuota(runId, token) { return this.request(this.buildConciliacionApiUrl(`/reconciliation-runs/${runId}/installment-recovery/preview`), { headers: this.buildHeaders(token), cache: "no-store" }); },

  async obtenerRunConciliacion(runId, filtros = {}, token) {
    return this.request(this.buildConciliacionApiUrl(`/runs/${runId}`), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...filtros, token }),
      cache: "no-store",
    });
  },

  async revisarResultadoConciliacion(runId, resultadoId, payload, token) {
    return this.request(this.buildConciliacionApiUrl(`/runs/${runId}/resultados/${resultadoId}/revision`), {
      method: "POST",
      headers: {
        ...this.buildHeaders(token),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...payload, token }),
    });
  },

  buildDownloadUrl(id, tipo, token) {
    return this.buildUrl(`/${id}/descargas/${tipo}`, token);
  },

  buildHeaders(token) {
    return {
      "X-CRM-Token": token || "",
    };
  },

  buildUrl(baseUrl, token, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        query.append(key, value);
      }
    });

    if (token) {
      query.append("token", token);
    }

    query.append("_", Date.now().toString());
    const suffix = query.toString() ? `?${query}` : "";
    return `${this.buildApiUrl(baseUrl)}${suffix}`;
  },

  buildApiUrl(path) {
    return `${API_BASE}${path}`;
  },

  buildConciliacionApiUrl(path) {
    return `${CONCILIACION_API_BASE}${path}`;
  },

  async request(url, options = {}) {
    const { debugLabel, ...fetchOptions } = options;
    const response = await fetch(url, fetchOptions);
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("text/html")) {
      // El status distingue la causa: 200 = cayo en el fallback del SPA (ruta inexistente en el
      // backend publicado); 413/502/504 = IIS o el proxy cortaron el request antes de la API.
      const error = new Error(`La API devolvio HTML en lugar de JSON. Verifique la configuracion del backend. (HTTP ${response.status})`);
      error.status = response.status;
      throw error;
    }

    const payload = await response.json().catch(() => ({}));
    if (debugLabel === "Historial") {
      console.log("Historial status", response.status);
      console.log("Historial payload", payload);
    }
    if (!response.ok) {
      const error = new Error(payload?.mensaje || payload?.error || "No se pudo completar la operacion.");
      error.status = response.status;
      error.body = payload;
      throw error;
    }

    return payload;
  }
};

export const importacionOperacionesApiConfig = {
  API_ROOT,
  API_BASE,
  CONCILIACION_API_BASE,
};
